import React, {Component} from 'react';
import connectWithRouter from 'shared/components/redux/connectWithRouter';
import styles from '../AccountPageStyles';
import InlineNotification from 'crazyEditor/components/EditorUI/BaseUI/InlineMessages/InlineNotification';
import _ from 'lodash';
import RaisedButton from 'material-ui/RaisedButton';
import TextField from 'material-ui/TextField';
import {checkCircle} from 'shared/icons';
import validator from 'validator';
import {updateProfile, changePassword} from 'MyAccount/ViewDesigns/helpers/preferencesHelper';
import {updateUserData} from 'MyAccount/ViewDesigns/redux/modules/user';
import {Profile as ProfileData} from '../AccountPageSectionsData';

const COLUMN_WIDTH = 200;

@connectWithRouter(
  state => ({
    name: state.user.name,
    email: state.user.email,
  }),
  {updateUserData}
)
export class Profile extends Component {
  constructor(props) {
    const {email, name} = props;
    super();
    this.state = {
      statusMessage: null,
      enteredEmail: email,
      enteredName: name,
      error: {},
    };
  }

  componentWillReceiveProps(nextProps) {
    const {email, name} = nextProps;
    this.setState({
      enteredEmail: email,
      enteredName: name,
    });
  }

  handleSaveNewPassword = () => {
    const {updateUserData} = this.props;
    const {newPasswordRepeat, newPassword, currentPassword} = this.state;
    if (newPassword === currentPassword) {
      this.setState({statusMessage: null, error: {newPasswordError: 'This is the same password as the old one'}});
      return;
    }
    if (newPassword !== newPasswordRepeat) {
      this.setState({statusMessage: null, error: {newPasswordRepeatError: "New password doesn't match"}});
      return;
    }
    this.setState({statusMessage: null, error: {}});
    changePassword(currentPassword, newPassword)
      .then(response => {
        if (response.success) {
          updateUserData(response.user);
          this.setState({
            statusMessage: 'Password changed successfully',
            newPasswordRepeat: null,
            newPassword: null,
            currentPassword: null,
          });
        } else {
          this.setState({error: {currentPasswordError: response.message || 'Unknown Error'}});
        }
      })
      .fail(result => {
        this.setState({error: {currentPasswordError: result.responseJSON.message || 'Unknown Error'}});
      });
  };

  handleUpdate = () => {
    const {email, name, enteredEmail, enteredName, password} = this.state;
    const {updateUserData} = this.props;
    if (!validator.isEmail(enteredEmail, {allow_utf8_local_part: false})) {
      this.setState({error: {emailError: 'Please enter a valid email address'}});
      return;
    }
    this.setState({statusMessage: null, error: {}});
    if (name !== enteredName || email !== enteredEmail) {
      updateProfile({name: enteredName, email: enteredEmail, password})
        .then(response => {
          if (response.success) {
            updateUserData(response.user);
            this.setState({statusMessage: 'Profile updated successfully'});
          } else {
            this.setState({error: {[`${response.errorField}Error`]: response.message || 'Unknown Error'}});
          }
        })
        .fail(result => {
          const response = result.responseJSON;
          this.setState({error: {[`${response.errorField}Error`]: response.message || 'Unknown Error'}});
        });
    }
  };

  render() {
    const {name, email} = this.props;
    const {
      statusMessage,
      enteredEmail,
      enteredName,
      newPasswordRepeat,
      newPassword,
      currentPassword,
      error,
      password,
    } = this.state;
    let updateEnabled =
      !_.isEmpty(enteredEmail) && !_.isEmpty(enteredName) && (enteredEmail !== email || enteredName !== name);
    const saveNewPasswordEnabled =
      !_.isEmpty(newPassword) && !_.isEmpty(newPasswordRepeat) && !_.isEmpty(currentPassword);
    const passwordFieldStyle = {...styles.inputField, transition: 'all 200ms cubic-bezier(0.23, 1, 0.32, 1) 0ms'};
    if (enteredEmail === email) {
      passwordFieldStyle.height = 0;
      passwordFieldStyle.opacity = 0;
    } else {
      if (_.isEmpty(password)) {
        updateEnabled = false;
      }
    }
    return (
      <div style={styles.pageContentContainer} id={'cla-profile-container'}>
        <div style={styles.h1} id={'cla-profile-ttl'}>
          Profile
        </div>
        <InlineNotification
          open={!!statusMessage}
          style={{height: 80, marginTop: 15, marginBottom: 15, marginLeft: 10, marginRight: 10, maxWidth: 560}}
          onRequestClose={() => {
            this.setState({statusMessage: null});
          }}
          iconPath={checkCircle}
        >
          {statusMessage}
        </InlineNotification>
        <div style={{display: 'flex', flexWrap: 'wrap', maxWidth: 240 + COLUMN_WIDTH * 2}}>
          <div
            style={{display: 'flex', flexDirection: 'column', width: COLUMN_WIDTH, marginRight: 240, marginBottom: 30}}
          >
            <div style={styles.h2} id={'cla-profile-subttl-basinfo'}>
              Basic Information
            </div>
            <TextField
              floatingLabelText="Name"
              defaultValue={name}
              onChange={event => this.setState({enteredName: event.target.value})}
              onKeyDown={event => {
                if (event.keyCode === 13 && updateEnabled) this.handleUpdate();
              }}
              style={styles.inputField}
              id={'cla-profile-field-name'}
            />
            <TextField
              floatingLabelText="Email"
              defaultValue={email}
              onChange={event => this.setState({enteredEmail: event.target.value})}
              errorText={error.emailError}
              onKeyDown={event => {
                if (event.keyCode === 13 && updateEnabled) this.handleUpdate();
              }}
              style={styles.inputField}
              id={'cla-profile-field-email'}
            />
            <TextField
              floatingLabelText="Password"
              type="password"
              onChange={event => this.setState({password: event.target.value})}
              errorText={error.passwordError}
              onKeyDown={event => {
                if (event.keyCode === 13 && updateEnabled) this.handleUpdate();
              }}
              style={passwordFieldStyle}
            />
            <RaisedButton
              primary
              style={{width: '100%', marginTop: 30}}
              label="update"
              disabled={!updateEnabled}
              onClick={this.handleUpdate}
              id={'cla-profile-btn-updateinfo'}
            />
          </div>
          <div style={{display: 'flex', flexDirection: 'column', width: COLUMN_WIDTH}}>
            <div style={styles.h2} id={'cla-profile-subttl-change-pwd'}>
              Change Password
            </div>
            <TextField
              floatingLabelText="Current Password"
              type="password"
              value={currentPassword || ''}
              onChange={event => this.setState({currentPassword: event.target.value})}
              errorText={error.currentPasswordError}
              onKeyDown={event => {
                if (event.keyCode === 13 && saveNewPasswordEnabled) this.handleSaveNewPassword();
              }}
              style={styles.inputField}
              id={'cla-profile-field-curr-pwd'}
            />
            <TextField
              floatingLabelText="New Password"
              type="password"
              value={newPassword || ''}
              onChange={event => this.setState({newPassword: event.target.value})}
              errorText={error.newPasswordError}
              onKeyDown={event => {
                if (event.keyCode === 13 && saveNewPasswordEnabled) this.handleSaveNewPassword();
              }}
              style={styles.inputField}
              id={'cla-profile-field-new-pwd'}
            />
            <TextField
              floatingLabelText="Retype New Password"
              type="password"
              value={newPasswordRepeat || ''}
              onChange={event => this.setState({newPasswordRepeat: event.target.value})}
              errorText={error.newPasswordRepeatError}
              onKeyDown={event => {
                if (event.keyCode === 13 && saveNewPasswordEnabled) this.handleSaveNewPassword();
              }}
              style={styles.inputField}
              id={'cla-profile-field-retype-new-pwd'}
            />
            <RaisedButton
              primary
              style={{width: '100%', marginTop: 30}}
              label="save new password"
              disabled={!saveNewPasswordEnabled}
              onClick={this.handleSaveNewPassword}
              id={'cla-profile-btn-save-new-pwd'}
            />
          </div>
        </div>
      </div>
    );
  }
}

export default _.assign(Profile, ProfileData);
